import React from 'react';
import { FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router-dom';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Divider from '@material-ui/core/Divider';
import Splash from '../components/Splash';
import View from './views';

const styles = theme => ({
  divider: {
    margin: `${theme.spacing(2)}px 0`
  }
});

export function NotFoundView({ classes, location, history }) {
  View.NotFound404.visit();
  return (
    <Splash
      content={
        <>
          <Divider className={classes.divider} />
          <Typography gutterBottom variant="h6">
            <FormattedMessage id="notFoundView.title" />
          </Typography>
          <Typography component="p" />
          <FormattedMessage
            id="notFoundView.description"
            values={{ pathname: <code>{location.pathname}</code> }}
          />
        </>
      }
      actions={
        <Button
          onClick={() => history.push('/')}
          type="submit"
          size="small"
          color="secondary"
        >
          <FormattedMessage id="notFoundView.buttonGoToRoot" />
        </Button>
      }
    />
  );
}

export default withRouter(withStyles(styles)(NotFoundView));
